module.exports = __webpack_public_path__ + "static/media/progress_header_5.f7aa0795.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/progress_header_5.svg
// module id = 540
// module chunks = 0